"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withProvider = void 0;
const react_1 = require("react");
const Provider_1 = require("./Provider");
/**
 * Оборачивает переданный компонент в провайдер ленивых сервисов.
 *
 * @param pool Пул сервисов, который будет использован в провайдере. Если
 * не указан, то будет создан новый пул.
 */
exports.withProvider = (pool) => (target) => { var _a; return _a = class WithProvider extends react_1.Component {
        /**
         * @inheritdoc
         */
        render() {
            return react_1.createElement(Provider_1.Provider, { pool }, react_1.createElement(target, this.props));
        }
    },
    /**
     * @inheritdoc
     */
    _a.displayName = `WithServiceProvider(${target.displayName || target.name})`,
    _a; };
